import { useState, useEffect } from 'react';

/**
 * Hook para calcular distribución de comisiones.
 * @param {Object} canalData - Objeto del Canal (Padre).
 * @param {Object} subcanalData - Objeto del Subcanal (Asociado).
 * @param {string} grupoRiesgo - 'PATRIMONIALES' o 'ART' (Viene del objeto de Riesgo seleccionado).
 * @param {string} compania - Nombre de la compañía (Para reglas específicas de ART).
 */
export const useReglasComision = (canalData, subcanalData, grupoRiesgo, compania) => {
    
    const [comisionCanal, setComisionCanal] = useState('');       
    const [comisionSubcanal, setComisionSubcanal] = useState(''); 
    const [descuentoCanal, setDescuentoCanal] = useState('');
    const [descuentoSubcanal, setDescuentoSubcanal] = useState('');
    const [formaPago, setFormaPago] = useState('');
    const [cuitCanal, setCuitCanal] = useState('');
    const [habilitarEdicion, setHabilitarEdicion] = useState(false);

    useEffect(() => {
        // Reset si falta info
        if (!canalData || !grupoRiesgo) {
            setComisionCanal(''); setComisionSubcanal('');
            setDescuentoCanal(''); setDescuentoSubcanal('');
            setFormaPago(''); setCuitCanal('');
            setHabilitarEdicion(false);
            return;
        }

        setCuitCanal(canalData.cuit || '');

        // --- ESCENARIO A: PATRIMONIALES ---
        if (grupoRiesgo === 'PATRIMONIALES') {
            setFormaPago(canalData.formaLiquidarPatrimoniales || 'Comisión');

            if (subcanalData) {
                // Hay Asociado -> Usar reglas de distribución del subcanal
                const reglasPat = subcanalData.patrimoniales || {};
                setComisionCanal(reglasPat.distribucionCanal || 0);
                setComisionSubcanal(reglasPat.distribucionSubcanal || 0);
                setDescuentoCanal(reglasPat.descuentoCanal || 0);   
                setDescuentoSubcanal(reglasPat.descuentoSubcanal || 0);   
                setHabilitarEdicion(true); 
            } else {
                // Solo Canal Padre -> Usar base del canal
                setComisionCanal(canalData.porcentajePatrimoniales || 0);
                setComisionSubcanal(''); 
                setDescuentoCanal(canalData.descuento || 0); 
                setDescuentoSubcanal('');
                setHabilitarEdicion(false); 
            }
        } 
        
        // --- ESCENARIO B: ART ---
        else if (grupoRiesgo === 'ART') {
            setFormaPago(canalData.formaLiquidarART || 'Comisión');
            
            if (subcanalData) {
                // Hay Asociado -> Buscar regla por compañía
                const reglasArt = subcanalData.artReglas || [];
                const reglaCia = reglasArt.find(r => r.compania === compania);

                if (reglaCia) {
                    setComisionCanal(reglaCia.distCanal || 0);
                    setComisionSubcanal(reglaCia.distSub || 0);
                    setDescuentoCanal(reglaCia.descCanal || 0);
                    setDescuentoSubcanal(reglaCia.descSub || 0);
                } else {
                    // Sin regla específica
                    setComisionCanal(0); setComisionSubcanal(0);
                    setDescuentoCanal(0); setDescuentoSubcanal(0);
                }
                setHabilitarEdicion(true);
            } else {
                // Solo Canal Padre -> Buscar excepción por compañía
                const excepciones = canalData.artEspeciales || [];
                const excepcionCia = excepciones.find(e => e.compania === compania);
                
                if (excepcionCia) {
                    setComisionCanal(excepcionCia.porcentaje);
                } else {
                    setComisionCanal(0); 
                }
                setComisionSubcanal('');
                setDescuentoCanal(canalData.descuento || 0); 
                setDescuentoSubcanal('');
                setHabilitarEdicion(true); 
            }
        }
        
        else {
            setFormaPago('');
            setComisionCanal('');
            setHabilitarEdicion(true);
        }

    }, [canalData, subcanalData, grupoRiesgo, compania]);

    return {
        comisionCanal,
        comisionSubcanal,
        descuentoCanal,
        descuentoSubcanal,
        formaPago,
        cuitCanal,
        habilitarEdicion
    };
};